import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Award, GraduationCap, Stethoscope, Calendar, Mail, Shield, MapPin, Sparkles } from 'lucide-react';

const doctors = [
  {
    name: 'Dr. Kyle J. Moyles',
    credentials: 'MD, MBA',
    role: 'Hand & Upper Extremity Surgeon',
    image: 'https://customer-assets.emergentagent.com/job_handcare-redesign/artifacts/8erb7qwb_images-2.jpeg',
    bio: 'Dr. Moyles is a native of Brevard County and is continuing his family\'s strong tradition of medical service to the community. He is a graduate of Melbourne Central Catholic High School (Valedictorian, 2000), the University of Florida, and the Florida State University College of Medicine.',
    fullBio: 'He completed his orthopaedic surgery residency at the University of Miami (2012) and his hand surgery fellowship at Brown University (2013), under the mentorship of Dr. Edward Akelman (President of the American Society for Surgery of the Hand). He also earned an M.B.A from Florida Atlantic University in 2013. He is board certified as a Diplomate of the American Board of Orthopaedic Surgeons.',
    specialties: [
      'Carpal Tunnel Surgery',
      'Trigger Finger Release',
      'Wrist Arthroscopy',
      'Hand & Wrist Fractures',
      'Cubital Tunnel Release',
      'Ganglion Cyst Removal',
      'Tendon Repair',
    ],
    education: [
      'University of Florida - B.A. Magna Cum Laude, 2003',
      'Florida State University College of Medicine - M.D., 2007',
      'Florida Atlantic University - M.B.A., 2013',
    ],
    training: [
      'Orthopaedic Surgery Residency - University of Miami, 2012',
      'Hand Surgery Fellowship - Brown University, 2013',
    ],
    certifications: [
      'Board Certified - American Board of Orthopaedic Surgeons',
      'Diplomate - American Board of Orthopaedic Surgeons',
    ],
    affiliations: [
      'Clinical Assistant Professor - UCF College of Medicine',
      'Clinical Assistant Professor - FSU College of Medicine',
      'Former President - Brevard County Medical Society',
    ],
    email: 'info@melbournehandcenter.com',
  },
  {
    name: 'Dr. Brandon D. Frye',
    credentials: 'DO',
    role: 'Orthopedic Hand Specialist',
    image: 'https://customer-assets.emergentagent.com/job_handcare-redesign/artifacts/wlxd6pdd_images-3.jpeg',
    bio: 'Dr. Brandon D. Frye is a board-certified orthopaedic surgeon specializing in conditions of the hand and upper extremity. As a retired U.S. Army Lieutenant Colonel, he has nearly 2 decades of combat medical experience, including combat tours in Iraq and Afghanistan.',
    fullBio: 'Most recently, Dr. Frye was the Orthopedic Clinic Chief, and the sole Orthopaedic Hand Surgeon, at Blanchfield Army Community Hospital, providing hand and upper extremity orthopaedic care to more than 82,000 Soldiers, family members, and retirees within the Fort Campbell, KY community.',
    specialties: [
      'Hand & Upper Extremity Surgery',
      'Complex Fracture Care',
      'Nerve Compression Surgery',
      'Tendon Repair',
      'Dupuytren\'s Contracture',
      'Sports & Athletic Injuries',
      'Elbow Surgery',
    ],
    education: [
      'University of Florida - B.S. in Zoology & Botany, 2002',
      'Des Moines University College of Osteopathic Medicine - D.O., 2007',
    ],
    training: [
      'Traditional Rotating Internship - Largo Medical Center, 2008',
      'Orthopaedic Surgery Residency - William Beaumont Army Medical Center, 2015',
      'Hand & Upper Extremity Surgery Fellowship - Florida Orthopaedic Institute, 2016',
    ],
    certifications: [
      'Board Certified - Orthopaedic Surgery',
      'Board Certified - Orthopaedic Surgery of the Hand',
      'Diplomate - American Board of Orthopaedic Surgeons',
    ],
    affiliations: [
      'Fellow - American Academy of Orthopaedic Surgeons (AAOS)',
      'Member - American Society for Surgery of the Hand (ASSH)',
      'Retired U.S. Army Lieutenant Colonel',
    ],
    email: 'info@melbournehandcenter.com',
  },
  {
    name: 'Dr. Lacie M. Turnbull',
    credentials: 'MD',
    role: 'Hand, Upper Extremity & Microvascular Surgeon',
    image: 'https://customer-assets-v7afamib.emergentagent.net/job_43690aae-dd1b-4f7d-bb2c-3c7d3ec71533/artifacts/6skni19o_Professional%20Photo_LT%20Fellowship.jpeg',
    bio: 'Dr. Lacie Monique Turnbull is an orthopaedic hand surgeon specializing in comprehensive care of the hand, wrist, forearm, and peripheral nerves. She joins Melbourne Hand Center after completing an advanced Orthopaedic Surgery Hand, Upper Extremity, and Microvascular Fellowship at Brown University. Dr. Turnbull completed her orthopaedic surgery residency at the University of Florida and earned her medical degree from the University of Central Florida College of Medicine, where she graduated top in her class and received multiple awards for academic excellence, professionalism, leadership, and service.',
    fullBio: "Through fellowship-level training, Dr. Turnbull has developed specialized expertise in complex reconstructive and arthroplasty procedures of the hand and wrist. Her clinical interests include thumb CMC arthroplasty; MCP and PIP joint arthroplasty; wrist arthroplasty; wrist arthroscopy and athletic injuries; acute and chronic wrist and finger trauma, including complex distal radius fractures; tendon and ligament repair and reconstruction; carpal and cubital tunnel; and trigger finger. Her advanced peripheral nerve training includes nerve decompression, repair, and nerve transfers. Dr. Turnbull's fellowship training also includes microsurgical reconstruction, vascular repair, and upper-extremity replantation, with additional microsurgery training at the National University Hospital Department of Hand and Reconstructive Microsurgery in Singapore. An active researcher and educator, she has authored peer-reviewed publications and textbook chapters and presented research nationally and internationally.",
    specialties: [
      'Thumb CMC Arthroplasty',
      'MCP & PIP Joint Arthroplasty',
      'Wrist Arthroplasty',
      'Wrist Arthroscopy',
      'Carpal Tunnel Release',
      'Cubital Tunnel Release',
      'Nerve Decompression & Repair',
      'Athletic Hand & Wrist Injuries',
      'Complex Fracture & Ligament Reconstruction',
    ],
    education: [
      'University of Michigan - B.S., Major in Neuroscience with Highest Honors and Distinction, 2014',
      'University of Central Florida College of Medicine - M.D., 2020 (Graduated top in class)',
    ],
    training: [
      'Orthopaedic Surgery Residency - University of Florida, 2020–2025',
      'Hand, Upper Extremity & Microvascular Fellowship - Brown University, 2025–2026',
      'Microsurgery Training - National University Hospital, Singapore',
    ],
    certifications: [
      'Fellowship Trained - Hand, Upper Extremity & Microvascular Surgery',
      'Dean\'s Award - UCF College of Medicine, 2020',
      'Alpha Omega Alpha Medical Honor Society',
    ],
    affiliations: [
      'Member - American Society for Surgery of the Hand (ASSH)',
      'Member - American Academy of Orthopaedic Surgeons (AAOS)',
      'Member - Ruth Jackson Orthopaedic Society',
      'Member - Florida Orthopaedic Society',
    ],
    email: 'info@melbournehandcenter.com',
  },
];

const DoctorsPage = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-hero py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center gap-2 bg-primary/10 text-primary px-4 py-2 rounded-full mb-6">
            <Stethoscope className="w-4 h-4" />
            <span className="text-sm font-semibold">Our Specialists</span>
          </div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground mb-6">
            Meet Your Hand Surgeons
          </h1>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Our board-certified orthopedic surgeons are fellowship-trained specialists 
            dedicated exclusively to treating conditions of the hand and upper extremity.
          </p>
        </div>
      </section>

      {/* Doctors Section */}
      <section className="py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-16">
            {doctors.map((doctor, index) => (
              <Card key={doctor.name} className="bg-card border-0 shadow-xl overflow-hidden">
                <CardContent className="p-0">
                  <div className={`grid lg:grid-cols-2 ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
                    {/* Image */}
                    <div className={`relative h-96 lg:h-auto ${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                      <img 
                        src={doctor.image} 
                        alt={doctor.name}
                        className="w-full h-full object-cover object-top"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-foreground/60 via-transparent to-transparent lg:hidden" />
                      <div className="absolute bottom-4 left-4 right-4 lg:hidden">
                        <h2 className="font-display text-2xl font-bold text-card">{doctor.name}, {doctor.credentials}</h2>
                        <p className="text-card/90">{doctor.role}</p>
                      </div>
                    </div>

                    {/* Content */}
                    <div className={`p-8 lg:p-12 ${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                      <div className="hidden lg:block mb-6">
                        <h2 className="font-display text-3xl font-bold text-foreground">{doctor.name}, {doctor.credentials}</h2>
                        <p className="text-primary font-medium">{doctor.role}</p>
                      </div>
                      
                      <p className="text-muted-foreground mb-4">{doctor.bio}</p>
                      <p className="text-muted-foreground mb-8">{doctor.fullBio}</p>

                      {/* Areas of Expertise (specialty tags) */}
                      <div className="mb-8">
                        <h3 className="flex items-center gap-2 font-display text-lg font-semibold text-foreground mb-3">
                          <Sparkles className="w-5 h-5 text-primary" />
                          Areas of Expertise
                        </h3>
                        <ul
                          className="flex flex-wrap gap-2"
                          data-testid={`specialties-${doctor.name.replace(/\s+/g, '-').toLowerCase()}`}
                        >
                          {doctor.specialties.map((s) => (
                            <li
                              key={s}
                              className="inline-flex items-center px-3 py-1.5 rounded-full bg-primary/10 text-primary text-xs font-medium border border-primary/20"
                            >
                              {s}
                            </li>
                          ))}
                        </ul>
                      </div>

                      {/* Education */}
                      <div className="mb-6">
                        <h3 className="flex items-center gap-2 font-display text-lg font-semibold text-foreground mb-3">
                          <GraduationCap className="w-5 h-5 text-primary" />
                          Education
                        </h3>
                        <ul className="space-y-2">
                          {doctor.education.map((edu, i) => (
                            <li key={i} className="text-sm text-muted-foreground pl-7">• {edu}</li>
                          ))}
                        </ul>
                      </div>

                      {/* Training */}
                      <div className="mb-6">
                        <h3 className="flex items-center gap-2 font-display text-lg font-semibold text-foreground mb-3">
                          <Award className="w-5 h-5 text-primary" />
                          Training
                        </h3>
                        <ul className="space-y-2">
                          {doctor.training.map((train, i) => (
                            <li key={i} className="text-sm text-muted-foreground pl-7">• {train}</li>
                          ))}
                        </ul>
                      </div>

                      {/* Certifications */}
                      <div className="mb-6">
                        <h3 className="flex items-center gap-2 font-display text-lg font-semibold text-foreground mb-3">
                          <Shield className="w-5 h-5 text-primary" />
                          Board Certifications
                        </h3>
                        <ul className="space-y-2">
                          {doctor.certifications.map((cert, i) => (
                            <li key={i} className="text-sm text-muted-foreground pl-7">• {cert}</li>
                          ))}
                        </ul>
                      </div>

                      {/* Actions */}
                      <div className="flex flex-wrap gap-4 pt-6 border-t border-border">
                        <Button variant="hero" size="lg" asChild>
                          <a 
                            href="https://app.acuityscheduling.com/schedule.php?owner=13861726"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <Calendar className="w-5 h-5 mr-2" />
                            Book Appointment
                          </a>
                        </Button>
                        <Button variant="outline" size="lg" asChild>
                          <a href={`mailto:${doctor.email}`}>
                            <Mail className="w-5 h-5 mr-2" />
                            Contact
                          </a>
                        </Button>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Location Section */}
      <section className="py-16 bg-gradient-subtle">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="font-display text-3xl font-bold text-foreground mb-4">Visit Our Office</h2>
            <p className="text-muted-foreground">Conveniently located in Melbourne, Florida</p>
          </div>
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <Card className="bg-card border-0 shadow-card">
              <CardContent className="p-8">
                <div className="flex items-start gap-4 mb-6">
                  <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-6 h-6 text-primary" />
                  </div>
                  <div>
                    <h3 className="font-display text-xl font-semibold text-foreground mb-2">Melbourne Hand Center</h3>
                    <p className="text-muted-foreground">2010 W. Eau Gallie Blvd</p>
                    <p className="text-muted-foreground">Suite 104</p>
                    <p className="text-muted-foreground">Melbourne, FL 32935</p>
                  </div>
                </div>
                <div className="space-y-3 text-muted-foreground">
                  <p><strong className="text-foreground">Phone:</strong> 321.500.HAND (4263)</p>
                  <p><strong className="text-foreground">Fax:</strong> 888.782.9622</p>
                  <p><strong className="text-foreground">Email:</strong> info@melbournehandcenter.com</p>
                  <p><strong className="text-foreground">Hours:</strong> Monday - Friday, 8:00 AM - 5:00 PM</p>
                </div>
              </CardContent>
            </Card>
            <div className="rounded-xl overflow-hidden shadow-lg h-80">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3520.6367693547776!2d-80.65148392358652!3d28.106947411867997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88de1234567890ab%3A0x0!2s2010%20W%20Eau%20Gallie%20Blvd%2C%20Melbourne%2C%20FL%2032935!5e0!3m2!1sen!2sus!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Melbourne Hand Center Location"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DoctorsPage;
